/** imported components

  * Modal for ===> component of material-ui to use for popups.
  * $ for ===> component from jquery to use jquery on the page.
  * Helmet ===> for add specific title & CSS for the page.
  * useState, useEffect ===> React hooks (useState is a way to get/set value)
  * serviceProvider for ===> working with api

**/
import React, { useState, useEffect } from 'react';
import { Modal, Collapse, TextField } from '@material-ui/core'
import $ from "jquery";
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import serviceProvider from '../../services/axios'

export const AssignSectionPopup = (props) => {
    const [msAssignSearch, setMsAssignSearch] = useState('');
    const [invitedMember, setInvitedMember] = useState([]);
    const [isInvite, setIsInvite] = useState(false);
    const [multiEmailVal, setMultiEmailVal] = useState([]);
    const [singleEmail, setSingleEmail] = useState("");
    const [olduser, setOldUser] = useState([]);
    const [olduserid, setOlduserId] = useState([]);
    const [isEmailSent, setIsEmailSent] = useState(false);
    const [selectedOwners, setSelectedOwners] = useState([]);
    const [classstatus, setClassstaus] = useState(false);

    
    
   

    useEffect(()=>{
        if(!props.open){
          setSelectedOwners([]);
          setOldUser([])
          setOlduserId([])
        }  
  
      },[props.open])
    
    
    const HandleSelectedOwners = (val) => {
       
        let tmpArr = [...selectedOwners];
       
        if (tmpArr.indexOf(val.name) === -1) {
            tmpArr.unshift(val.name);
            setSelectedOwners(tmpArr);
            setOldUser(val.email);
            setOlduserId(val.id);
            // setClassstaus("active");
        } else {
            let filterArr = tmpArr.filter((item, index) => {
                return item !== val.name;
            });
            setSelectedOwners(filterArr);
            setOldUser(val.email);
            
        }
       
        
    }

  
    const RemoveOwner = (tmpIndex) => {
        let filterArr = selectedOwners.filter((item, index) => {
            return tmpIndex !== index;
        });
        setSelectedOwners(filterArr);
    }
    const HandleSingleEmailValue = (e) => {
        let tmpValue = e.target.value;
        setSingleEmail(tmpValue);
    };
    const AddMultiEmail = (e) => {
        // let tmpArr = [...multiEmailVal];
        let tmpArr =[];
        const emailRegx =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        if (e.key === "Enter" && emailRegx.test(String(singleEmail).toLowerCase()) && tmpArr.indexOf(singleEmail) === -1) {
            const addEmail = singleEmail;
            tmpArr.push(addEmail);
            setSingleEmail("");
            setMultiEmailVal(tmpArr);
        }
    };
    const RemoveEmail = (e) => {
        let filterEmail = multiEmailVal.filter((item, index) => {
            return e !== index;
        });
        setMultiEmailVal(filterEmail);
    };
    const handleClose = () => {
        props.setOpen(!props.open);
        setIsInvite(false);
    }
    const HandleValue = (e) => {
        let val = e.target.value;
        setMsAssignSearch(val);
        let filterArr = invitedMember.filter((item, index) => {
            return item.name.toLowerCase().startsWith(val.toLowerCase());
        });
        if (val.length > 0) {
            setInvitedMember(filterArr);
        } else {
            setInvitedMember(invitedMember);
        }
    }

    


    const user = JSON.parse(localStorage.getItem("userData"));
    const usid = user ? user.uid : 0;
    const username1 = user ? user.name :'';
    
    const HandleInvite = () => {
        let username = props.tmpAssignUser;
        let name = multiEmailVal[0];
        // console.log(name);
        let tmpObj = {
            ...props.assignedUsers,
            [username]:name
        };
        if (multiEmailVal != '') {
            setIsEmailSent(true);
            setTimeout(() => {
              setIsEmailSent(false);
              props.setAssignedUsers(tmpObj);
              handleClose();
            }, 2000)
      
      
            serviceProvider.post("/plants?type=assessment_team_invite", JSON.stringify({ email: name, uid: usid, invitation_category:categoryid, role: 1, plants:plantid }), true).then((response) => {
              console.log("mail send-", response);
            });
      
          }
 
   }

   
   
    
    const handleAssign = ()=>{
        let username = props.tmpAssignUser;
        let name = selectedOwners[0];
        console.log(name);
        
        if (olduser != '') {
            let tmpObj = {
                ...props.assignedUsers,
                [username]:name
            };
            setIsEmailSent(true);
            props.setAssignedUsers(tmpObj);
            setTimeout(() => {
              setIsEmailSent(false);
              handleClose();
            }, 2000)
      console.log(plantid);
      
            serviceProvider.post("/plants?type=assessment_team_invite", JSON.stringify({ email: olduser, invited_uid:olduserid,  uid: usid, teamName: selectedOwners[0], invitation_category:categoryid, invitation_type:1, plants:plantid }),true).then((response) => {
              console.log("mail send-", response);
            });
      
          }
         
        
        
    }


    const loadUserList = async () => {
        const result = await serviceProvider.get(`/plants/UserList?user_id=${usid}`,true,{});
        const data1 = result.data
        console.log(data1)
        const data2 = data1[0].uerstatus;
        const data3 = Array.from(new Set(data2.map(d=>d.email)))
        const options1 = data3.map(email=>({
            "id": data2.find(d=>d.email===email).id,
            "name": data2.find(d=>d.email===email).name + " " + data2.find(d=>d.email===email).last_name,
            "circleName": data2.find(d=>d.email===email).name.charAt(0) + "" + data2.find(d=>d.email===email).last_name.charAt(0),
             "invited": [],
            "email" : email
        }));
        setInvitedMember(options1);
   
      };
    
      useEffect(() => {
       loadUserList();
      }, []);

    const categoryid = props.catagory;
    if(!categoryid){
        return null;
    }

    const categName = props.catagoryName;
    const plantid = props.plant_id;

    return (
        <>
            {/* specific css file that is used for this page */}
            <Helmet>
                    <link rel="stylesheet" href={require('./assessment-assign-popup.scss').default} />
            </Helmet>
            {/* Here is the modal which is containing assessment assign popup.*/}
            <Modal open={props.open}
                // onClose={handleClose}
                 className="assessment-assign-popup">
                {/* Assign popup wrapper has been started. This is containing all the popup elements*/}
                <div className="ms-assign-section-popup">
                    <div className="ms-assign-section-card">
                        {!isEmailSent ?
                            <>
                                <div className="ms-assign-header">
                                    <span>{`Assign team member to ${categName}`}</span>
                                    <button className="close-btn" onClick={handleClose}>
                                        <img src={require('../../assets/img/maturity-dashboard/cancel-dark.svg').default} alt="X" />
                                    </button>
                                </div>
                                {/* assign popup-header end */}
                                <div className="ms-assign-content">
                                    <div className="ms-select-owner-div" style={{ display: isInvite ? 'none' : '' }}>
                                        <div className={`ms-assign-search-box ${msAssignSearch.length > 0 ? 'active' : ''}`}>
                                            <label className="ms-assign-search">
                                                <img src={require('../../assets/img/maturity-dashboard/ms-assign-search.svg').default} alt="true" />
                                                <input type="text" placeholder="Search.." onChange={(e) => HandleValue(e)} value={msAssignSearch} />
                                            </label>
                                        </div>
                                        {/* assign popup-search-box end */}
                                        <div className="ms-invite-div">
                                            <p>Select Owners</p>
                                            <button className="btn-invite" onClick={() => { setIsInvite(true) }}>
                                                Email Invite
                                            </button>
                                        </div>
                                        <div className="contact-empty-div" style={{ display: invitedMember.length > 0 ? 'none' : '' }}>
                                            <p>Your contact list is empty.</p>
                                            <p>Click on <span className="blue-link">Email Invite</span> to assign owners.</p>
                                        </div>

                                        <div className="ms-assign-scroll-div">
                                            <div className="selected-member-ul" style={{ display: selectedOwners.length > 0 ? '' : 'none' }}>
                                                {selectedOwners.map((item, index) => <div className="selected-member-li">
                                                    <span>{item}</span>
                                                    <button className="remove-list" onClick={() => RemoveOwner(index)}>
                                                        <img src={require('../../assets/img/maturity-dashboard/email-list-cancel.svg').default} alt="X" />
                                                    </button>
                                                </div>)}
                                            </div>

                                            <div className="select-owner-text" style={{ display: selectedOwners.length > 0 ? '' : 'none' }}>
                                                Select Owners
                                            </div>
                                            <div className="ms-cir-list-wrapper">
                                                {invitedMember.map((item, index) => <div dataid={index} className={`ms-cir-li ${selectedOwners.indexOf(item.name) !== -1 && classstatus}`} onClick={(e) => HandleSelectedOwners(item)} key={index}>
                                                    <div className={`ms-cir-div cir-${item.name[0].toLocaleLowerCase()}`}>{item.circleName}</div>
                                                    <div className="ms-cir-name">
                                                        <span>{item.name} </span>
                                                    </div>
                                                    <img className="selected-icon" src={require('../../assets/img/maturity-dashboard/cir-select-chk.svg').default} />
                                                </div>)}
                                            </div>
                                        </div>
                                    </div>
                                    {/* assign-popup-select-owner-div end */}
                                    <div className="ms-invite-member-div" style={{ display: !isInvite ? 'none' : '' }}>
                                        <div className={`ms-assign-search-box ${msAssignSearch.length > 0 ? 'active' : ''}`}>
                                            <label className="ms-assign-search">
                                                <img src={require('../../assets/img/maturity-dashboard/ms-assign-search.svg').default} alt="true" />
                                                <input type="text" placeholder="Search.." onChange={(e) => HandleValue(e)} value={msAssignSearch} />
                                            </label>
                                        </div>
                                        {/* assign-popup-search-box end */}
                                        <div className="ms-invite-div">
                                            <p>Email Invite</p>
                                        </div>
                                        <div className="email-input-wrapper">
                                            <label className="label">
                                                <span className="input-title">Email</span>
                                                <input type="text" value={singleEmail} onChange={(e) => HandleSingleEmailValue(e)} onKeyPress={(e) => AddMultiEmail(e)} className="input-field" placeholder="Type e-mail address" />
                                            </label>
                                        </div>
                                        <div className="ms-assign-scroll-div">
                                            <div className="selected-member-ul">
                                                {multiEmailVal.map((item, index) => <div className="selected-member-li">
                                                    <span>{item}</span>
                                                    <button className="remove-list" onClick={() => RemoveEmail(index)}>
                                                        <img src={require('../../assets/img/maturity-dashboard/email-list-cancel.svg').default} alt="X" />
                                                    </button>
                                                </div>)}
                                            </div>
                                        </div>
                                    </div>
                                    {/* ms-select-owner-div end */}
                                </div>
                                {/* ms-assign-content end */}
                                <div className="ms-assign-footer">
                                    {!isInvite ?
                                        <>
                                            <button className="ms-assign-btn cancel" onClick={handleClose}>
                                                Cancel
                                            </button>
                                            <button className="ms-assign-btn blue" onClick={handleAssign}>
                                                Assign
                                            </button>
                                        </>
                                        :
                                        <>
                                            <button className="ms-assign-btn cancel" onClick={() => setIsInvite(false)}>
                                                Back
                                            </button>
                                            <button className="ms-assign-btn blue" onClick={() => HandleInvite()}>
                                                Send Invite
                                            </button>
                                        </>
                                    }

                                </div>
                                {/* assign-popup footer end */}
                            </>
                            :
                            <div className="invite-successful">
                                <img src={require('../../assets/img/maturity-dashboard/done-check.png').default} alt="invite successfully" />
                                <p>
                                    Email invite successfully sent!
                                </p>
                            </div>
                        }
                    </div>
                </div>
            </Modal>
        </>
    )
}

